import {isObject} from '@raison/toolbox';
import {sentryFeedBack} from '~/shared/api/legacy_services/sentry';
import {apiPost} from '~/shared/utils/api_legacy';
import {appLocalStorage} from '../../persistence';

export interface LogsInterface {
    level: 'info' | 'notice' | 'warning' | 'error';
    message: string;
    tags: string[]; // any words you want
}

export const sendLogs = async ({level, message, tags}: LogsInterface) => {
    try {
        await apiPost('/api/v1/public/log', {data: {level, message, tags}});
    } catch (error: unknown) {
        if (isObject(error) && 'code' in error && error.code === 401) {
            return;
        } else {
            sentryFeedBack('Logs', 'Send personalized error logs error', {error});
        }
    }
};

export const sendPersonalizedErrorLogs = ({level, message, tags}: LogsInterface) => {
    const username = appLocalStorage.username.get();
    const messageContext = {username, error: message};
    return sendLogs({level, message: JSON.stringify(messageContext), tags});
};
